import { makeStyles, theme } from 'cdh-data-portal-theme'
import { TOPBAR_HEIGHT, TOP_MARGIN } from './Topbar.static'

export const useStyles = makeStyles()(() => ({
  appBar: {
    background: theme.colors.primary,
    boxShadow: theme.shadows.weak,
    borderRadius: 8,
    zIndex: theme.zIndex.modal - 1,
    padding: '0 20px 0 24px',
    position: 'fixed',
    top: TOP_MARGIN,
    left: 0,
    height: TOPBAR_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: `calc(100vw - ${2 * theme.globalPadding}px - ${theme.scrollBarPadding}px)`,
    marginTop: theme.globalPadding,
    marginLeft: theme.globalPadding,
    marginRight: theme.globalPadding,
  },
  mask: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: TOP_MARGIN + theme.globalPadding + TOPBAR_HEIGHT,
    background: theme.colors.globalBackgroundLight,
    zIndex: theme.zIndex.modal - 2,
  },
  leftSection: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  rightSection: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  brand: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    textDecoration: 'none',
  },
  operationsHubText: {
    "&&": {
      fontSize: 16,
      fontWeight: 500,
    },
  },
  internalWarningText: {
    "&&": {
      color: theme.textColors.highlight,
      fontSize: 11,
      fontWeight: 600,
    },
    backgroundColor: theme.colors.globalBackgroundDark,
    padding: '2px 6px',
    borderRadius: 4,
  },
}))
